<template>
  <div class="pl-4 bg-white" :style="{ height: channel == 'proxy' ? 'auto' : 'calc(100% - 98px);' }">
    <div class="flex">
      <div class="left pt-4" :style="{ flex:'auto',width: 'calc(100% - 330px)' }">
        <div class="welcome-pages" v-if="propsWelcomeShow">
          <div v-if="channel == 'randomInterviewer'" class="welcome-pages-wrap">
            <div class="welcome-pages-center">
              <div class="welcome-title">随机样本面访</div>
              <div class="welcome-desc" v-html="'随机拦访样本开展调查，保证调查结果的客观性<br/>调查员通过“ 调研工厂调查员版 App ”开展调查，全程录音录像，支持离线调查，生成调查员调查轨迹。'"></div>
              <el-button type="primary" @click="$emit('welcomeAddInterviewer')">随机样本面访</el-button>
              <img class="welcome-img" src="@/assets/img/wj/random-welcome.png" />
            </div>
          </div>
          <div v-else-if="channel == 'telephoneInterviewer'" class="welcome-pages-wrap">
            <div class="welcome-pages-center">
              <div class="welcome-title">CATI 云电话调查</div>
              <!-- <div class="welcome-desc">随机拦访样本开展调查，保证调查结果的客观性</div> -->
              <div class="welcome-desc" v-html="'支持在线自动拨号，多坐席管理，通话状态跟踪，全过程录音'"></div>
              <el-button type="primary" @click="$emit('welcomeAddInterviewer')">添加电话调查</el-button>
              <img class="welcome-img" src="@/assets/img/wj/CATI-welcome.png" />
            </div>
          </div>
        </div>  
        <div class="select-page" v-else>
          <div v-if="tableCount == 0 && tableType !== 'taskTable'" v-loading="loading">
            <slot name="selected-left"></slot>
            <el-empty class="pt-40" :description="tableType === 'taskTable' ? '还未分配调查员' : '暂无数据'"></el-empty>
          </div>
          <div v-else class="h-full">
            <div v-show="flag">
              
              <div class="selected-interviewer">
                <!-- 四个搜索 -->
                <div :class="{ 'justify-between': searchRight&&(!!$slots['selected-left']),'flex':!!$slots['selected-left'] }">
                  <slot name="selected-left"></slot>
                  <ul class="flex flex-wrap" :class="{ 'justify-end': searchRight }">
                    <li class="mr-3 mb-3" style="width: 103px">
                      <el-input
                        :placeholder="inputPlaceholder.name"
                        v-model="searchParams.commonName"
                      >
                      </el-input>
                    </li>
                    <li class="mr-3 mb-3" style="width: 108px" v-if="channel === 'proxy' ? false : true">
                      <el-input
                        :placeholder="inputPlaceholder.phone"
                        v-model="searchParams.commonPhone"
                      >
                      </el-input>
                    </li>
                    <li class="mr-3 mb-3" style="width: 118px">
                      <el-input
                        :placeholder="inputPlaceholder.taskName"
                        v-model="searchParams.commonTaskName"
                      >
                      </el-input>
                    </li>
                    <li class="mr-3 mb-3" style="width: 108px">
                      <!-- 选择任务状态 -->
                      <el-select v-model="searchParams.taskStatusValue" :placeholder="inputPlaceholder.taskState">
                        <el-option v-for="item in taskStatus" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                      </el-select>
                    </li>
                    <li class="mb-3" style="width: 200px" v-if="importBool === 'import'">
                      <el-button class="mr-0.5" type="primary" @click="toSearch">
                        <span class="px-0.5">查询</span>
                      </el-button>
                      <el-button size="small" @click="onReset">
                        <span class="px-0.5">重置</span>
                      </el-button>
                      <el-button class="p-0.5 border-0" @click="handleExportTable">导出</el-button>
                    </li>
                    <li class="" style="width: 140px" v-else>
                      <el-button class="mr-0.5" type="primary" @click="toSearch">
                        <span class="px-0.5">查询</span>
                      </el-button>
                      <el-button size="small" @click="onReset">
                        <span class="px-0.5">重置</span>
                      </el-button>
                    </li>
                  </ul>
                </div>
                <el-table
                  class="data-table"
                  :data="tableData"
                  style="width: 100%"
                  v-if="isShow"
                  :span-method="channel == 'proxy' || tableType === 'taskTable' ? spanMethodProxy : spanMethod"
                  v-loading="loading"
                  @selection-change="selectionChangeHandler"
                  :row-key="rowKeyHandler"
                  ref="tableRef"
                  @select="select"
                  @select-all="selectAllChange"
                  :height="
                    channel == 'randomInterviewer'
                      ? 'calc(100vh - 251px)'
                      : channel == 'telephoneInterviewer'
                      ? (activeCallType === 5 ? 'calc(100vh - 283px)' : 'calc(100vh - 203px)')
                      : 'calc(100vh - 245px)'
                  "
                >
                  <template v-if="tableType === 'taskTable'">
                    <el-table-column prop="equalName" :label="tableColumnName.name" align="left" min-width="60"></el-table-column>
                    <el-table-column prop="equalPhone" :label="tableColumnName.concat" align="left" min-width="105"></el-table-column>
                    <el-table-column
                      prop="equalTaskName"
                      :label="tableColumnName.taskName"
                      align="left"
                      min-width="188"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.equalTaskName" v-show="scope.row.show"></el-input>
                        <span v-show="!scope.row.show">{{ scope.row.equalTaskName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="equalTaskEndTime" :label="tableColumnName.taskEndTime" align="left" min-width="160">
                      <template slot-scope="scope">
                        <el-date-picker
                          v-model="scope.row.equalTaskEndTime"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期时间"
                          v-show="scope.row.show"
                        ></el-date-picker>
                        <span v-show="!scope.row.show">{{ scope.row.equalTaskEndTime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="equalState" :label="tableColumnName.taskStatus" align="left" min-width="70">
                      <template slot-scope="scope">
                        <div v-if="scope.row.status === 6"><span class="mr-0.5" style="color: #e8a31b">●</span>已分配</div>
                        <div v-else-if="scope.row.status === 11"><span class="mr-0.5" style="color: #00be6a">●</span>已承接</div>
                        <div v-else-if="scope.row.status === 12">
                          <span class="mr-0.5" style="color: rgba(0, 0, 0, 0.15)">●</span>已拒接
                        </div>
                        <div v-else-if="scope.row.status === 7">
                          <span class="mr-0.5" style="color: rgba(0, 0, 0, 0.15)">●</span>已关闭
                        </div>
                        <div v-else-if="scope.row.status === 13"><span class="mr-0.5" style="color: #00be6a">●</span>已完成</div>
                        <!-- <div v-else-if="scope.row.status === 6"><span class="mr-0.5" style="color: #00be6a">●</span>已分配</div> -->
                        <div v-else-if="scope.row.status === 8"><span class="mr-0.5" style="color: #e34152">●</span>已结算</div>
                        <div v-else-if="scope.row.status === 9"><span class="mr-0.5" style="color: #e8a31b">●</span>邀请中</div>
                        <div v-else-if="scope.row.status === 10"><span class="mr-0.5" style="color: #2775e8">●</span>已邀请</div>
                        <div v-else-if="scope.row.status === 1"><span class="mr-0.5" style="color: #e8a31b">●</span>待承接</div>
                        <div v-else-if="scope.row.status === 0"><span class="mr-0.5" style="color: #e8a31b">●</span>已分配</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="settleMethod" :label="tableColumnName.settleMethod" align="left" min-width="85">
                      <template slot-scope="scope">
                        <span v-if="!scope.row.settleMethod||scope.row.settleMethod === 0">线上结算</span>
                        <span v-else-if="scope.row.settleMethod === 1">线下结算</span>
                        <span v-else-if="scope.row.settleMethod === 2">无需结算</span>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="settleMode" :label="tableColumnName.settleMode" align="left" width="480">
                      <template slot-scope="scope">
                        <div v-if="scope.row.settleMethod==2">无</div>
                        <div v-else class="flex">
                          <template>
                            <span v-if="scope.row.settleMode === 1">按答卷数量</span>
                            <span v-else-if="scope.row.settleMode === 2">按天</span>
                            <span v-else-if="scope.row.settleMode === 3">按阶梯计价</span>
                            <span v-else>-</span>
                          </template>
                          <template>
                            <span v-if="scope.row.settleRule"
                              >{{ scope.row.settleMode === 1 ? '，回收 ' : '，工作' }}{{ scope.row.settleRule.expectedQuantity }} {{ scope.row.settleMode === 1 ? '份' : '天' }}</span
                            >
                            <span v-else>-</span>
                          </template>
                          <template>
                            <div v-if="scope.row.settleMode === 1">，每份 {{ scope.row.settleRule.unitPriceYuan }} 元</div>
                            <div v-else-if="scope.row.settleMode === 2">，每天 {{ scope.row.settleRule.unitPriceYuan }} 元</div>
                            <div v-else-if="scope.row.settleMode === 3">
                              <span>
                                ，每天回收 1~{{
                                  scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].quantityUpperBound
                                }} 份
                              </span>
                              <span v-if="scope.row.settleRule.tiers.length === 1">
                                ，最高每份 {{ scope.row.settleRule.tiers[0].unitPriceYuan }}元
                              </span>
                              <span v-else>
                                ，最高每份 {{scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan}}元
                                <!-- {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                                  scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                                }}元 -->
                              </span>
                            </div>
                            <div v-else>-</div>
                          </template>
                        </div>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="expectedQuantity" :label="tableColumnName.expectedQuantity" align="left" min-width="60">
                      <template slot-scope="scope">
                        <span v-if="scope.row.settleRule"
                          >{{ scope.row.settleRule.expectedQuantity }} {{ scope.row.settleMode === 1 ? '份' : '天' }}</span
                        >
                        <span v-else>-</span>
                      </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="unitPriceYuan" :label="tableColumnName.unitPriceYuan" align="left" min-width="100">
                      <template slot-scope="scope">
                        <div v-if="scope.row.settleMode === 1">{{ scope.row.settleRule.unitPriceYuan }}元/份</div>
                        <div v-else-if="scope.row.settleMode === 2">{{ scope.row.settleRule.unitPriceYuan }}元/天</div>
                        <div v-else-if="scope.row.settleMode === 3">
                          <span v-if="scope.row.settleRule.tiers.length === 1">
                            {{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份
                          </span>
                          <span v-else>
                            {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                              scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                            }}元/份
                          </span> -->
                          <!-- <el-tooltip placement="top">
                            <div slot="content">
                              <div v-if="scope.row.settleRule.tiers.length>1">
                                <div v-for="(it, i) in scope.row.settleRule.tiers" :key="i">
                                  <p :style="{ marginBottom: i === scope.row.settleRule.tiers.length - 1 ? '0' : '5px' }">
                                    <span v-if="i===0">每天</span>
                                    <span v-if="i===0">1份</span>
                                    <span v-else>{{ it.quantityLowerBound + 1 }}份</span>
                                    ~
                                    <span>{{ it.quantityUpperBound }}</span
                                    >份,
                                    <span style="margin-left: 3px">{{ it.unitPriceYuan }}元/份</span>
                                  </p>
                                </div>
                              </div>
                              <div v-else>
                                <span>每天{{scope.row.settleRule.tiers[0].unitPriceYuan}}元/份</span>
                              </div>

                            </div>
                            <i class="iconfont">&#xe63d;</i>
                          </el-tooltip> -->
                        <!-- </div>
                        <div v-else>-</div>
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      prop="equalCommitCount"
                      :label="tableColumnName.commitCount"
                      align="left"
                      min-width="70"
                    ></el-table-column>
                    <el-table-column
                      prop="equalEffectiveCount"
                      :label="tableColumnName.effectiveCount"
                      align="left"
                      min-width="70"
                    ></el-table-column>
                    <el-table-column prop="isOpen" :label="tableColumnName.switch" align="left" min-width="70">
                      <template slot-scope="scope">
                        <el-switch
                          v-model="scope.row.isOpen"
                          :disabled="!scope.row.edit"
                          @change="switchChangeHandler(scope.row, $event)"
                        ></el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column prop="assignedBy" label="分配人" align="left" min-width="115" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="options" label="操作" align="left" min-width="130" fixed="right">
                      <template slot-scope="scope">
                        <el-button
                          v-if="channel == 'randomInterviewer' || channel == 'proxy'"
                          type="text"
                          @click="newEditTable(scope.row)"
                          :disabled="!scope.row.edit"
                          >{{ scope.row.show ? '保存' : '编辑' }}</el-button
                        >
                        <el-button
                          v-if="['randomInterviewer', 'proxy'].includes(channel)"
                          type="text"
                          @click="newAddTable(scope.row)"
                          :disabled="!scope.row.edit"
                          >{{ scope.row.show ? '取消' : '添加任务' }}</el-button
                        >
                        <el-button v-if="channel == 'telephoneInterviewer'" @click="look(scope.row)" type="text">查看</el-button>
                        <el-button v-if="channel == 'telephoneInterviewer'" @click="addTelephoneNumber(scope.row)" type="text"
                          >添加任务</el-button
                        >
                      </template>
                    </el-table-column>
                  </template>
                  <template v-else>
                    <el-table-column type="selection" :selectable="displayCheckBox" reserve-selection></el-table-column>
                    <el-table-column prop="equalName" :label="tableColumnName.name" align="center" width="160"></el-table-column>
                    <el-table-column
                      v-if="channel === 'proxy' ? false : true"
                      prop="equalPhone"
                      :label="tableColumnName.concat"
                      align="center"
                      width="160"
                    ></el-table-column>
                    <!-- <el-table-column prop="equalPhone" :label="tableColumnName.concat" align="center" width="160"></el-table-column> -->
                    <el-table-column prop="equalTaskName" :label="tableColumnName.taskName" align="center" width="180">
                      <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.equalTaskName" v-show="scope.row.show"></el-input>
                        <span v-show="!scope.row.show">{{ scope.row.equalTaskName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="isQY && tableColumnName.jobForm" prop="jobForm" :label="tableColumnName.jobForm" align="left" min-width="160">
                      <template slot-scope="scope">
                        <span v-if="scope.row.jobForm === 3">固定样本</span>
                        <span v-else-if="scope.row.jobForm === 5">预测式外呼</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="equalTaskEndTime" :label="tableColumnName.taskEndTime" align="center" width="230">
                      <template slot-scope="scope">
                        <el-date-picker
                          v-model="scope.row.equalTaskEndTime"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期时间"
                          v-show="scope.row.show"
                        ></el-date-picker>
                        <span v-show="!scope.row.show">{{ scope.row.equalTaskEndTime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="equalState" :label="tableColumnName.taskStatus" align="center" width="100">
                      <template slot-scope="scope">
                        <div v-if="scope.row.status === 11"><span class="mr-0.5" style="color: #00be6a">●</span>已承接</div>
                        <div v-else-if="scope.row.status === 12">
                          <span class="mr-0.5" style="color: rgba(0, 0, 0, 0.15)">●</span>已拒接
                        </div>
                        <div v-else-if="scope.row.status === 7">
                          <span class="mr-0.5" style="color: rgba(0, 0, 0, 0.15)">●</span>已关闭
                        </div>
                        <div v-else-if="scope.row.status === 13"><span class="mr-0.5" style="color: #00be6a">●</span>已完成</div>
                        <div v-else-if="scope.row.status === 8"><span class="mr-0.5" style="color: #e34152">●</span>已结算</div>
                        <div v-else-if="scope.row.status === 9"><span class="mr-0.5" style="color: #e8a31b">●</span>邀请中</div>
                        <div v-else-if="scope.row.status === 10"><span class="mr-0.5" style="color: #2775e8">●</span>已邀请</div>
                        <div v-else-if="scope.row.status === 1"><span class="mr-0.5" style="color: #e8a31b">●</span>待承接</div>
                        <div v-else-if="scope.row.status === 0 || scope.row.status === 6"><span class="mr-0.5" style="color: #e8a31b">●</span>已分配</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="settleMethod" :label="tableColumnName.settleMethod" align="left" min-width="85">
                      <template slot-scope="scope">
                        <span v-if="!scope.row.settleMethod||scope.row.settleMethod === 0">线上结算</span>
                        <span v-else-if="scope.row.settleMethod === 1">线下结算</span>
                        <span v-else-if="scope.row.settleMethod === 2">无需结算</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="settleMode" :label="tableColumnName.settleMode" align="left" width="480">
                      <template slot-scope="scope">
                        <div v-if="scope.row.settleMethod==2">无</div>
                        <div v-else class="flex">
                          <template>
                            <span v-if="scope.row.settleMode === 1">按答卷数量</span>
                            <span v-else-if="scope.row.settleMode === 2">按天</span>
                            <span v-else-if="scope.row.settleMode === 3">按阶梯计价</span>
                            <span v-else>-</span>
                          </template>
                          <template>
                            <span v-if="scope.row.settleRule"
                              >{{ scope.row.settleMode === 1 ? '，回收 ' : '，工作 ' }}{{ scope.row.settleRule.expectedQuantity }} {{ scope.row.settleMode === 1 ? ' 份' : ' 天' }}</span
                            >
                            <span v-else>-</span>
                          </template>
                          <template>
                            <div v-if="scope.row.settleMode === 1">，每份 {{ scope.row.settleRule.unitPriceYuan }} 元</div>
                            <div v-else-if="scope.row.settleMode === 2">，每天 {{ scope.row.settleRule.unitPriceYuan }} 元</div>
                            <div v-else-if="scope.row.settleMode === 3">
                              <span>
                                ，每天回收 1~{{
                                  scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].quantityUpperBound
                                }} 份
                              </span>
                              <span v-if="scope.row.settleRule.tiers.length === 1">
                                ，最高每份 {{ scope.row.settleRule.tiers[0].unitPriceYuan }} 元
                              </span>
                              <span v-else>
                                ，最高每份 {{scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan}} 元
                                <!-- {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                                  scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                                }}元 -->
                              </span>
                              <el-tooltip placement="top">
                                <div slot="content">
                                  <div v-if="scope.row.settleRule.tiers.length > 1">
                                    <div v-for="(it, i) in scope.row.settleRule.tiers" :key="i">
                                      <p :style="{ marginBottom: i === scope.row.settleRule.tiers.length - 1 ? '0' : '5px' }">
                                        <span v-if="i === 0">每天</span>
                                        <span v-if="i === 0">1份</span>
                                        <span v-else>{{ it.quantityLowerBound + 1 }}份</span>
                                        ~
                                        <span>{{ it.quantityUpperBound }}</span
                                        >份,
                                        <span style="margin-left: 3px">{{ it.unitPriceYuan }}元/份</span>
                                      </p>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <span>每天{{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份</span>
                                  </div>
                                </div>
                                <i class="iconfont">&#xe63d;</i>
                              </el-tooltip>
                            </div>
                            <div v-else>-</div>

                          </template>
                        </div>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="expectedQuantity" :label="tableColumnName.expectedQuantity" align="center" width="180">
                      <template slot-scope="scope">
                        <span v-if="scope.row.settleRule"
                          >{{ scope.row.settleRule.expectedQuantity }} {{ scope.row.settleMode === 1 ? '份' : '天' }}</span
                        >
                        <span v-else>-</span>
                      </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="unitPriceYuan" :label="tableColumnName.unitPriceYuan" align="center" width="180">
                      <template slot-scope="scope">
                        <div v-if="scope.row.settleMode === 1">{{ scope.row.settleRule.unitPriceYuan }}元/份</div>
                        <div v-else-if="scope.row.settleMode === 2">{{ scope.row.settleRule.unitPriceYuan }}元/天</div>
                        <div v-else-if="scope.row.settleMode === 3">
                          <span v-if="scope.row.settleRule.tiers.length === 1">
                            {{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份
                          </span>
                          <span v-else>
                            {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                              scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                            }}元/份
                          </span>
                          <el-tooltip placement="top">
                            <div slot="content">
                              <div v-if="scope.row.settleRule.tiers.length > 1">
                                <div v-for="(it, i) in scope.row.settleRule.tiers" :key="i">
                                  <p :style="{ marginBottom: i === scope.row.settleRule.tiers.length - 1 ? '0' : '5px' }">
                                    <span v-if="i === 0">每天</span>
                                    <span v-if="i === 0">1份</span>
                                    <span v-else>{{ it.quantityLowerBound + 1 }}份</span>
                                    ~
                                    <span>{{ it.quantityUpperBound }}</span
                                    >份,
                                    <span style="margin-left: 3px">{{ it.unitPriceYuan }}元/份</span>
                                  </p>
                                </div>
                              </div>
                              <div v-else>
                                <span>每天{{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份</span>
                              </div>
                            </div>
                            <i class="iconfont">&#xe63d;</i>
                          </el-tooltip>
                        </div>
                        <div v-else>-</div>
                      </template>
                    </el-table-column> -->
                  

                    <!-- <el-table-column
                      prop="equalCount"
                      :label="tableColumnName.count"
                      align="center"
                      width="140"
                    >
                      <template slot-scope="scope">
                        <el-input-number
                          size="small"
                          v-model="scope.row.equalCount"
                          v-show="scope.row.show"
                          @change="equalCountChange($event, scope.row, 'equalCount')"
                          :controls="true"
                          :min="1"
                        ></el-input-number>
                        <span v-show="!scope.row.show">{{ scope.row.equalCount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="equalPrice"
                      :label="tableColumnName.price"
                      align="center"
                      width="140"
                    >
                      <template slot-scope="scope">
                        <el-input-number
                          size="small"
                          v-model="scope.row.equalPrice"
                          v-show="scope.row.show"
                          :min="1"
                          :precision="2"
                          :controls="true"
                          :step="0.01"
                          @change="equalCountChange($event, scope.row, 'equalPrice')"
                        ></el-input-number>
                        <span v-show="!scope.row.show">{{ scope.row.equalPrice }}</span>
                      </template>
                    </el-table-column> -->

                    <el-table-column
                      prop="equalCommitCount"
                      :label="tableColumnName.commitCount"
                      align="center"
                      width="100"
                    ></el-table-column>
                    <el-table-column
                      prop="equalEffectiveCount"
                      :label="tableColumnName.effectiveCount"
                      align="center"
                      width="100"
                    ></el-table-column>
                    <el-table-column prop="isOpen" :label="tableColumnName.switch" align="center" width="150">
                      <template slot-scope="scope">
                        <el-switch
                          v-model="scope.row.isOpen"
                          :disabled="scope.row.taskStatus === 5 || (activeCallType === 5 && !predictCall)"
                          @change="switchChangeHandler(scope.row, $event)"
                        ></el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column prop="options" label="操作" align="center" width="130" fixed="right">
                      <template slot-scope="scope">
                        <!-- @click="editTable(scope.row)" -->
                        <el-button
                          v-if="channel == 'randomInterviewer' || channel == 'proxy'"
                          type="text"
                          @click="newEditTable(scope.row)"
                          :disabled="!scope.row.edit"
                          >{{ scope.row.show ? '保存' : '编辑' }}</el-button
                        >
                        <el-button
                          v-if="['randomInterviewer', 'proxy'].includes(channel)"
                          type="text"
                          @click="newAddTable(scope.row)"
                          :disabled="!scope.row.edit"
                          >{{ scope.row.show ? '取消' : '添加任务' }}</el-button
                        >
                        <el-button v-if="channel == 'telephoneInterviewer'" @click="look(scope.row)" type="text">编辑</el-button>
                        <el-button v-if="channel == 'telephoneInterviewer'" @click="addTelephoneNumber(scope.row)" type="text"
                          >添加任务</el-button
                        >
                      </template>
                    </el-table-column>
                  </template>
                </el-table>

                <!-- 底部--批量分配任务按钮和分页器 -->
                <div class="footer flex justify-between mt-4">
                  <div :style="{ visibility: tableType === 'taskTable' ? 'hidden' : 'visible' }">
                    <div class="inline-block mr-3 ml-3.5">
                      <el-checkbox
                        :indeterminate="isIndeterminate && !isAll && !!tableData.length"
                        :value="(selectAll || isAll) && !!tableData.length"
                        @input="changeTableSelect"
                      >
                        <span class="text-black text-opacity-65 ml-1">
                          已选择
                          <span class="text-theme">{{ isAll ? total : selectioned.length }}</span>
                          项
                        </span>
                      </el-checkbox>
                      <!-- <el-checkbox
                        :indeterminate="isIndeterminate && !isAll && !!data.length"
                        :value="(selectAll || isAll) && !!data.length"
                        @input="onCheckedChange"
                      >
                        <span class="text-black text-opacity-65">选择全部</span>
                      </el-checkbox>-->
                    </div>
                    <el-button type="primary" @click="assign">批量分配任务</el-button>
                    <el-button v-show="channel === 'randomInterviewer'" type="primary" plain @click="openAndCloseTask('open')"
                      >开启任务</el-button
                    >
                    <el-button v-show="channel === 'randomInterviewer'" type="primary" plain @click="openAndCloseTask('close')"
                      >关闭任务</el-button
                    >
                  </div>

                  <div class>
                    <el-pagination
                      layout="total, prev, pager, next, jumper"
                      :total="total"
                      :current-page.sync="searchParams.current"
                      @current-change="currentChangeHandler"
                      :page-size.sync="pageSize"
                      :pager-count="5"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!flag" class="pb-11 pr-6" :style="{ height: 'calc(100vh - 98px)', overflow:'auto','box-sizing': 'border-box' }">
              <assign-task @comeback="comebackHandler" :data="selectedInterviewerInfo" v-if="channel == 'randomInterviewer'" />
              <assign-telephone-task
                v-if="channel == 'telephoneInterviewer'"
                :data="selectedInterviewerInfo"
                @comeback="comebackHandler"
                :title="$store.getters.title"
                @emitChange="$emit('changeDialogVisible', true)"
              />
              <assign-proxy-task
                v-if="channel == 'proxy'"
                :data="selectedInterviewerInfo"
                @comeback="comebackHandler"
                :title="$store.getters.title"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="(isShowRightAdv===1?false :true)&&flag" class="right px-3 bg-card-bg-gray" :style="{ width: '290px',flex:'none',background:'#fff' }">
        <div :style="{ overflow:'auto',height:'calc(100vh - 83px)' }">
          <Advert></Advert>
        </div>
      </div>
    </div>
   
    <!-- 电话访问【添加号码】dialog -->
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      title="添加号码"
      top="0"
      :visible.sync="telephoneInterviewerDialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <div class="px-3">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">原任务上添加</el-menu-item>
          <el-menu-item index="2">分配新任务</el-menu-item>
        </el-menu>
        <div v-if="activeIndex === '1'" class="flex flex-col origin-task">
          <span class="origin-task-text">添加样本电话号码</span>
          <el-input type="textarea" :placeholder="textareaPlaceholder" :rows="20" v-model="originTextareaContent"></el-input>
          <span class="self-center count-text">全部{{ originCount }}条</span>
        </div>

        <div v-else-if="activeIndex === '2'" class="new-task flex items-center justify-around">
          <div class="left flex flex-col">
            <span class="new-task-text">添加样本电话号码</span>
            <el-input type="textarea" :placeholder="textareaPlaceholder" :rows="20" v-model="newTextareaContent"></el-input>
            <span class="self-center count-text">全部{{ newCount }}条</span>
          </div>
          <!-- 右侧表单 -->
          <div class="right">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
              <el-form-item label="任务名称：" prop="taskName">
                <el-input v-model="form.taskName" placeholder="请输入任务名称"></el-input>
              </el-form-item>
              <!-- <el-form-item prop="price">
                <label slot="label">
                  答卷单价(元)
                  <el-tooltip content="“答卷单价”为回收答卷质控通过后调查员的到手金额" placement="top">
                    <span class="el-icon-question"></span>
                  </el-tooltip>：
                </label>
                <el-input-number
                  size="small"
                  v-model="form.price"
                  :min="1"
                  :precision="2"
                  :controls="true"
                  :step="0.01"
                  class="right-bug"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="样本数量：">
                {{ newCount }}
              </el-form-item> -->

              <el-form-item
                :style="{ marginBottom: form.settleMode ? '0' : '18px' }"
                label="结算方式："
                prop="settleMode"
                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
              >
                <el-radio-group v-model="form.settleMode" @change="changeSettlementType">
                  <el-radio :label="1">按答卷数量</el-radio>
                  <el-radio :label="2">按天</el-radio>
                  <el-radio :label="3">按阶梯计价</el-radio>
                </el-radio-group>
              </el-form-item>

              <div class="settlementType-style" style="margin: 16px 0" v-if="form.settleMode === 1">
                <div class="flex-box">
                  <el-form-item
                    label="单价（元）:"
                    prop="settleRule.unitPriceYuan"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model="form.settleRule.unitPriceYuan"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="2"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>元</span>
                </div>
                <div class="settlement-tips">
                  若用线上结算，请填写调查员到手金额，到手金额
                  <el-button type="text" @click="() => $emit('changeDialogVisible', true)">计算器</el-button>
                </div>
                <div class="flex-box">
                  <el-form-item
                    label=""
                    prop="settleRule.expectedQuantity"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model="form.settleRule.expectedQuantity"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>份</span>
                </div>
                <div class="settlement-tips" style="margin-bottom: 0">
                  预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元
                </div>
              </div>
              <div class="settlementType-style" style="margin: 16px 0" v-if="form.settleMode === 2">
                <div class="flex-box">
                  <el-form-item
                    label="单价（元）:"
                    prop="settleRule.unitPriceYuan"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="form.settleRule.unitPriceYuan"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="2"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>元</span>
                </div>
                <div class="settlement-tips">
                  若用线上结算，请填写调查员到手金额，到手金额
                  <el-button type="text" @click="() => $emit('changeDialogVisible', true)">计算器</el-button>
                </div>
                <div class="flex-box">
                  <span class="pos-abs-box">
                    <i>*</i>
                    天数:
                    <el-tooltip
                      effect="dark"
                      content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                      placement="top"
                    >
                      <div class="icon-wrap" style="margin-left: 4px">
                        <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </span>
                  <el-form-item
                    label=""
                    prop="settleRule.expectedQuantity"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="form.settleRule.expectedQuantity"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>天</span>
                </div>
                <div class="settlement-tips" style="margin-bottom: 0">
                  <div style="display: flex">
                    <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                    <el-tooltip
                      effect="dark"
                      :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                      placement="top"
                    >
                      <div class="icon-wrap">
                        <span class="icon-font ico-tips">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="settlementType-style" style="margin: 16px 0" v-if="form.settleMode === 3">
                <el-form-item class="is-require-task" style="margin-bottom: 0" label="单价（元）:">
                  <div
                    class="flex-settlement"
                    v-for="(item, index) in form.settleRule.tiers"
                    :key="index"
                    :style="{ marginBottom: index === form.settleRule.tiers.length - 1 ? '0px' : '5px' }"
                  >
                    <span style="margin-right: 8px" v-show="index === 0">每天</span>
                    <el-form-item label>
                      <el-input-number
                        v-if="index === 0"
                        :disabled="true"
                        placeholder=""
                        v-model="item.quantityLowerBound"
                        autocomplete="off"
                        controls-position="right"
                        :min="0"
                        :max="Infinity"
                        :precision="0"
                      >
                      </el-input-number>
                      <el-input-number
                        v-if="index > 0"
                        :disabled="true"
                        placeholder=""
                        :value="form.settleRule.tiers[index - 1].quantityUpperBound * 1"
                        autocomplete="off"
                        controls-position="right"
                        :min="0"
                        :max="Infinity"
                        :precision="0"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                    <el-form-item
                      label
                      :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                      :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model="item.quantityUpperBound"
                        autocomplete="off"
                        controls-position="right"
                        :min="index > 0 ? form.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                        :max="Infinity"
                        @change="val => currentInputNumber(val, item, index)"
                        :precision="0"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin: 0 8px">份，按完成量</span>
                    <el-form-item
                      label
                      :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                      :rules="[
                        {
                          required: true,
                          message: ' ',
                          trigger: 'change'
                        }
                      ]"
                      style="margin-left: 10px"
                    >
                      <el-input-number
                        placeholder=""
                        v-model.number="item.unitPriceYuan"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin-left: 8px">元/份</span>
                    <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                      ><i class="icon-font">&#xe68c;</i></el-button
                    >
                    <el-button
                      v-else-if="index === form.settleRule.tiers.length - 1"
                      @click="handleSettlement('remove', index)"
                      class="btn-style"
                      type="text"
                      ><i class="icon-font">&#xe68a;</i></el-button
                    >
                    <!-- <el-button @click="handleSettlement(index=== form.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
                  </div>
                  <div class="settlement-tips left-0">
                    若用线上结算，请填写调查员到手金额，到手金额
                    <el-button type="text" @click="() => $emit('changeDialogVisible', true)">计算器</el-button>
                  </div>
                </el-form-item>
                <div class="flex-box">
                  <el-form-item
                    style="margin-bottom: 0"
                    label="天数:"
                    prop="settleRule.expectedQuantity"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="form.settleRule.expectedQuantity"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>天</span>
                </div>
              </div>

              <!-- <el-form-item prop="executionValidateTo" label="截止时间:">
                <el-date-picker
                  class="el-form-input"
                  type="datetime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="form.executionValidateTo"
                />
              </el-form-item> -->

              <el-form-item label="截止时间：" prop="endTime">
                <!-- <el-date-picker v-model="form.taskName" placeholder="选择时间"></el-date-picker> -->
                <el-date-picker
                  v-model="form.endTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="预估费用：">
                <span>{{ aboutPrice }}元</span>
                <p class="inline-block ml-4" v-if="Number(GlobalConfig.getCompanyId())">
                  推荐您通过调研工厂与调查员进行结算，为您节约成本
                  <a class="text-blue cursor-pointer" @click="getMore">了解更多</a>
                </p>
              </el-form-item> -->
              <el-form-item label="描述：">
                <el-input v-model="form.description" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notCreateTelephoneTask">取 消</el-button>
        <el-button type="primary" @click="createTelephoneTask">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 电话访问查看抽屉 -->
    <el-drawer
      :title="showTaskTitle"
      :visible.sync="showTaskDrawer"
      :size="1194"
      :destroy-on-close="true"
      :before-close="handleShowTaskDrawerClose"
    >
      <ShowTask showTaskPage="telephoneInterviewer" :showTaskRows="showTaskRows" :showTaskType="showTaskType" :activeCallType="activeCallType" @cancel="handleShowTaskDrawerClose" @callbackClose="ShowTaskEvent"  :rows="curRows" @dialogChange="$emit('changeDialogVisible', true)"></ShowTask>
    </el-drawer>
    <OnlinePayService ref="onlinePayServiceVisible" />
    <modify-task
      :rowData="rowData"
      :type="taskType"
      :visible="modifyVisible"
      @callbackClose="customEvent"
    />
    <modify-proxyTask :rowData="rowData" :type="taskType" :visible="modifyProxyVisible" @callbackClose="customProxyEvent" />
    <BatchSetingTask :rowData="rowData" :selectDataList="selectedInterviewerInfo" type="add" :visible="batchSetingTaskVisible" @callbackClose="customBatchEvent" />
    <BatchAssignTelTask :selectedInterviewerInfo="selectedInterviewerInfo" :visible="batchAssignTelTaskVisible" @callbackClose="customBatchTelTaskEvent" />
    <!-- 同明察暗访拦截弹窗 -->
    <!-- <DialogVersion type="random" /> -->
  </div>
</template>

<script>
import assignTask from './AssignTask.vue'
import assignTelephoneTask from '@/views/survey/cati/components/AssignTelephoneTask.vue'
import { getRandomInterviewTableData, putOfflineTask, getOpenAndCloseTaskAPI } from '@/api/wenjuan/offline.js'
import { creatPhoneTask, updatePhoneList, checkPhoneList } from '@/api/wenjuan/telephone.js'
import { extendObject } from '@/assets/js/utils.js'
import { isLandline, isMobile } from '@/assets/js/validate.js'
import assignProxyTask from '@/views/survey/agency/components/AssignProxyTask.vue'
import OnlinePayService from '@/components/online-pay-service'
import GlobalConfig from '@/global/config'
import ShowTask from '@/views/survey/cati/components/task/ShowTask'
import * as XlsxUtil from '@/assets/js/XlsxUtil'
import modifyTask from '@/views/survey/offline/components/drawer/ModifyTask'
import modifyProxyTask from '@/views/survey/offline/components/drawer/ModifyProxyTask'
import BatchSetingTask from '@/views/survey/offline/components/drawer/BatchSetingTask'
import BatchAssignTelTask from '@/views/survey/offline/components/drawer/BatchAssignTelTask'
import Advert from '@/components/interview/advert/index.vue'
import DialogVersion from '@/views/survey/offline/components/dialog/DialogVersion.vue'
import { mapGetters } from 'vuex'


let index = 0 // 游标 这个游标不能放到 data 数据中 因为会导致表格合并无限循环

export default {
  name: 'SelecteInterviewer',
  components: {
    assignTask,
    assignTelephoneTask,
    assignProxyTask,
    OnlinePayService,
    ShowTask,
    modifyTask,
    modifyProxyTask,
    Advert,
    BatchSetingTask,
    BatchAssignTelTask,
    DialogVersion
  },
  props: {
    importBool: {
      type: String,
      default: ''
    },
    // 表示使用此组件的来源
    channel: {
      type: String,
      default: ''
    },
    // 传入的输入框 placeholder
    inputPlaceholder: {
      type: Object
    },
    // 传入的可以选择的状态
    taskStatus: {
      type: Array
    },
    // 表格列的名字配置
    tableColumnName: {
      type: Object
    },
    // 父组件传过来的 tableData
    propTableData: {
      type: Array,
      default: []
    },
    // 表格合并时依赖的字段名
    combineField: {
      type: Object
    },
    // 开关改变触发的改变函数
    switchChangeFunc: {
      type: Function,
      default: function () {}
    },
    // 用来解析不同的参数
    parseParamsFunc: {
      type: Function,
      default: function () {}
    },
    // 开关状态改变的成功回调函数
    successFunc: {
      type: Function,
      default: function () {}
    },
    // 新增项四个字段
    newField: {
      type: Object
    },
    // 新增项的参数处理函数
    addArrangeParams: {
      type: Function
    },
    createTaskFunc: {
      type: Function
    },
    total: {
      type: Number,
      default: 0
    },
    searchRight: {
      type: Boolean,
      default: false
    },
    checkAll: {
      // 是否全选
      type: Boolean,
      default: false
    },
    setTask: {
      type: Function
    },
    tableType: {
      type: String,
      default: ''
    },
    proxyType: {
      default: ''
    },
    isShowRightAdv: {
      default: ''
    },
    // 是否显示电话访问,随机面坊介绍页
    propsWelcomeShow:{
      type: Boolean,
      default: false
    },
    activeCallType: {
      type: [String, Number],
      default: null
    },
    predictCall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      GlobalConfig,
      pageSize: 20,
      isIndeterminate: false,
      curRows: {},
      showTaskDrawer: false,
      isShow: true,
      tableCount: 0,
      // 下面四个为顶部搜索条件使用的四个字段
      searchParams: {
        commonName: '', // 上面搜索框对应的名字 比如代理名称/调查员名称等
        commonPhone: '', // 上面搜索框对应的联系方式 比如代理的联系方式/调查员的联系方式等
        commonTaskName: '', // 上面搜索框对应的任务名称
        taskStatusValue: '', // 对应任务状态的 value
        current: 1,
        activeName: 'first'
      },
      selectedInterviewerInfo: new Map(),
      preAllInterviewerIdsStatus: [],
      selectioned: [],
      curAllKeysItems: [],
      selectionChangeFlag: false,

      loading: true,
      tableData: [], // 存放表格数据
      flag: true,

      spanArr: [], // 合并数组
      pos: [], // 标志哪个位置开始合并
      position: 0, // 记录一下【添加任务】后插入的位置

      changeFlag: false, // 用来判断是否切换页码导致的变化
      // selection_copy: [], // 备份一份 selection

      editTemData: {
        // 临时存放编辑状态下的字段
        temTaskName: '', // 任务名称
        temEndTime: '', // 任务截止时间
        temCount: '', // 答卷数量
        temPrice: '' // 答卷单价
      },

      telephoneInterviewerDialogVisible: false,
      activeIndex: '1',
      textareaPlaceholder:
        '请参照以下格式输入（每行一个手机号）：\n13900006666\n13699998888，张三\n15233334444，李四\n15911112222',
      originTextareaContent: '',
      newTextareaContent: '',
      form: {
        taskName: '',
        price: 0,
        amount: 1,
        endTime: '',
        description: '',
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      },
      currentRow: '',
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择截止时间', trigger: 'blur' }]
      },
      // 新增弹窗及相关属性
      modifyVisible: false,
      modifyProxyVisible: false,
      batchSetingTaskVisible:false,
      batchAssignTelTaskVisible:false,
      rowData: {},
      taskType: 'add',
      showTaskType:'edit',// 电话访问编辑任务弹窗
      showTaskRows:[], // 电话访问批量分配任务弹窗选中的数据
      showTaskTitle: '', // 电话访问弹窗标题
    }
  },
  methods: {
    handleShowTaskDrawerClose() {
      this.showTaskDrawer = false
      this.$emit('inputValueChange', this.temParams)
    },
    ShowTaskEvent(val,type){
      this.showTaskDrawer = val;
      if(type){
        this.$emit('inputValueChange', this.temParams)
      }
    },
    handleExportTable(){
      this.$emit('importTable')
    },
    toSearch() {
      this.temParams.current = 1
      this.$emit('inputValueChange', this.temParams)
    },
    onReset() {
      this.temParams = {
        commonName: '', // 上面搜索框对应的名字 比如代理名称/调查员名称等
        commonPhone: '', // 上面搜索框对应的联系方式 比如代理的联系方式/调查员的联系方式等
        commonTaskName: '', // 上面搜索框对应的任务名称
        taskStatusValue: '', // 对应任务状态的 value
        current: 1,
        activeName: 'first'
      }
      this.toSearch()
    },
    // 最新编辑功能
    newEditTable(row) {
      if (this.channel === 'proxy') {
        console.log(row)
        this.rowData = row
        this.taskType = 'edit'
        this.modifyProxyVisible = true
      } else {
        console.log(row)
        this.rowData = row
        this.taskType = 'edit'
        this.modifyVisible = true
      }
    },
    // 最新添加任务
    newAddTable(row) {
      if (this.channel === 'proxy') {
        console.log(row)
        this.rowData = row
        this.taskType = 'add'
        this.modifyProxyVisible = true
      } else {
        console.log(row)
        this.rowData = row
        this.taskType = 'add'
        this.modifyVisible = true
      }
    },

    // 【编辑/保存】按钮的操作
    editTable(row) {
      // show 为 true 时为编辑状态
      if (row.show) {
        if (row.isNew) {
          this.loading = true
          // 新增项的保存操作
          // 当前要操作项的数据 因为太长 所以直接赋值给data
          let data = this.tableData[this.position]
          if (!(data.equalTaskName && data.equalTaskEndTime && data.equalCount)) {
            this.$message.error('请将数据填写正确，不然无法操作！')
            this.loading = false
            return
          }
          if (data.equalTaskName.length > 20) {
            this.$message.error('任务名称不可以超过20个字符！')
            this.loading = false
            return
          }

          // 调用接口 创建真实任务
          this.createTaskFunc(this.addArrangeParams(data))
            .then(res => {
              if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return
              }
              this.$message.success('添加任务成功！')
              this.$emit('inputValueChange', this.temParams)
            })
            .catch(e => {
              this.$message.error(e.message)
            })
        } else {
          // 普通项点了保存之后的操作
          putOfflineTask({
            executionBy: row.executionBy,
            executionDescription: row.executionDescription,
            executionName: row.equalTaskName,
            executionQuantity: row.equalCount,
            executionSingleAmount: row.equalPrice,
            executionValidateTo: row.equalTaskEndTime,
            executorPhone: row.executorPhone,
            id: row.id,
            status: row.status
          })
            .then(res => {
              this.$message.success('保存成功！')
              // 恢复所有按钮状态 使得其他行可以点击
              this.enableEdit()
            })
            .catch(error => {
              this.$message.error(error.message)
            })

          this.clearTemData()
        }
      } else {
        // 点了编辑之后的操作
        // 把其他按钮置为 disabled 不能操作其他行
        this.notEdit(row)
        // 备份一份之前的信息 防止用户一会点击取消
        this.editTemData.temTaskName = row.equalTaskName
        this.editTemData.temEndTime = row.equalTaskEndTime
        this.editTemData.temCount = row.equalCount
        this.editTemData.temPrice = row.equalPrice
      }

      // 改变状态
      row.show = !row.show
    },
    // 【添加任务/取消】按钮的操作
    addOrCancel(row) {
      // show 为 true 时是取消按钮
      if (row.show) {
        if (row.isNew) {
          // 新增项的取消操作
          // 把新增项取消
          this.tableData.splice(this.position, 1)
          // 重新计算合并表格
          this.combineData()
        } else {
          // 普通项的取消操作 只在【随机面访】模块有
          // 点了取消之后进行的操作 恢复刚才的数据
          row.equalTaskName = this.editTemData.temTaskName
          row.equalTaskEndTime = this.editTemData.temEndTime
          row.equalCount = this.editTemData.temCount
          row.equalPrice = this.editTemData.temPrice
        }

        // 并把其他按钮都恢复状态
        this.enableEdit()

        row.show = false

        this.clearTemData()
      } else {
        let res = this.tableData.findIndex(item => item[this.combineField.id] === row[this.combineField.id])
        this.position = res + 1

        this.tableData.splice(this.position, 0, {
          equalName: row.equalName,
          equalPhone: row.equalPhone,
          equalTaskName: this.editTemData.temTaskName,
          equalTaskEndTime: this.editTemData.temEndTime,
          equalCount: this.editTemData.temCOunt,
          equalPrice: this.editTemData.temPrice,
          [this.combineField.name]: row[this.combineField.name],
          [this.combineField.concat]: row[this.combineField.concat],

          show: true,
          edit: true,
          isOpen: true,
          isNew: true
        })

        this.$emit('sendSomeInfo', row)

        this.notEdit(this.tableData[this.position])

        this.combineData()
      }
    },
    // 委托代理表格合并
    spanMethodProxy({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (row.rowspan) {
          if (this.tableData[rowIndex - 1] === undefined) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            }
          } else if (
            row.agentName !== this.tableData[rowIndex - 1].agentName ||
            row.executorPhone !== this.tableData[rowIndex - 1].executorPhone
          ) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      }
    },
    // 合并表格方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      const columnIndexArr = this.tableType === 'taskTable' ? [0, 1] : [0, 1, 2]
      // if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
      if (columnIndexArr.includes(columnIndex)) {
        if (rowIndex === this.pos[index][0]) {
          let set = new Set(this.pos[index][1].filter(item => item !== ''))
          if (set.size) {
            row.equalName = Array.from(set).join('、')
          } else {
            row.equalName = ''
          }
          if (columnIndex === 2) {
            return this.spanArr[index++]
          }
          return this.spanArr[index]
        } else {
          return [0, 0]
        }
      }
      index = index % this.pos.length
    },
    // 不能编辑其他行 指的是不能点击它上面的任何按钮
    notEdit(row) {
      this.tableData.forEach(item => {
        item.edit = false
      })
      row.edit = true
    },
    // 使所有行变得可以编辑
    enableEdit() {
      this.tableData.forEach(item => {
        item.edit = true
      })
    },
    // 判断哪些数据可以合并起来的逻辑函数
    combineData() {
      // 下面的这几个都需要重置 因为在变换页码时 如果是之前的东西 会导致表格错乱
      index = 0
      this.pos = []
      this.spanArr = []
      this.curAllKeysItems = []
      // 判断哪几条数据可以合并
      let count = 1 // 起计数作用 计算几行进行合并
      for (let i = 0; i < this.tableData.length; i++) {
        if (i === 0) {
          if (this.tableData[i][this.combineField.name] !== null) {
            this.pos.push([0, [this.tableData[i][this.combineField.name]]])
          } else {
            this.pos.push([0, ['']])
          }
          this.curAllKeysItems.push(this.tableData[0])
        } else {
          if (this.tableData[i][this.combineField.concat] == this.tableData[i - 1][this.combineField.concat]) {
            if (this.tableData[i][this.combineField.name] !== null) {
              let tem = this.pos.pop()
              this.pos.push([tem[0], [...tem[1], this.tableData[i][this.combineField.name]]])
            }
            count++ // 多一行合并
          } else {
            this.curAllKeysItems.push(this.tableData[i])
            this.spanArr.push([count, 1])
            this.pos.push([i, [this.tableData[i][this.combineField.name]]])
            count = 1
          }
        }
      }
      // console.log('pos:', this.pos)
      this.spanArr.push([count, 1])
      // 根据前一页状态给当前页状态赋值
      this.curAllKeysItems.forEach(item => {
        this.preAllInterviewerIdsStatus.forEach(i => {
          if (item[this.combineField.concat] == i[this.combineField.concat]) {
            if (i.checked == true) {
              this.selectionChangeFlag = true
              this.$nextTick(() => {
                this.$refs.tableRef.toggleRowSelection(item, true)
                this.selectAllChange(this.selectioned)
              })
            } else {
              this.selectionChangeFlag = true
              this.$nextTick(() => {
                this.$refs.tableRef.toggleRowSelection(item, false)
                this.selectAllChange(this.selectioned)
              })
            }
          }
        })
      })
    },
    // 批量开启/关闭任务
    openAndCloseTask(type) {
      if (!this.selectedInterviewerInfo.size) {
        if (this.channel == 'proxy') {
          this.$message.error('请先选择代理！')
        } else {
          this.$message.error('请先选择调查员！')
        }
        return
      }
      const ids = this.selectioned
        .map(it => ({ id: it.id }))
        .map(it => Object.values(it))
        .flat()
      getOpenAndCloseTaskAPI({
        ids: ids,
        type: type === 'open' ? 6 : 7
      }).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          // this.$emit('setTask',type)
          this.$message.success(type === 'open' ? '开关状态修改成功' : '开关状态修改关闭')
          this.$emit('inputValueChange', this.temParams)
        } else {
          this.$message.error('网络异常')
        }
      })
    },
    // 批量分配任务按钮
    assign() {
      if (!this.selectedInterviewerInfo.size) {
        if (this.channel == 'proxy') {
          this.$message.error('请先选择代理！')
        } else {
          this.$message.error('请先选择调查员！')
        }
        return
      }

      // console.log('curAllKeysItems', this.curAllKeysItems)
      // console.log('selectioned', this.selectioned)
      // console.log('this.curAllKeysItems',this.curAllKeysItems)
      // 判断当前为随机样本面访
      if(this.channel === 'randomInterviewer'){
        console.log('selectioned', this.selectioned)
        const equalPhoneList = this.selectioned.map(it=>(it.equalPhone))
        const equalPhoneArr = [...new Set(equalPhoneList)]
        console.log('equalPhoneArr',equalPhoneArr)
        console.log('selectedInterviewerInfo',this.selectedInterviewerInfo)
        this.batchSetingTaskVisible = true;

      }else if(this.channel === 'telephoneInterviewer'){
        this.showTaskTitle = '批量分配任务'
        const selectionedList = this.selectioned;
        let map = new Map();
          for (let item of selectionedList) {
              if (!map.has(item.executorPhone)) {
                  map.set(item.executorPhone, item);
              };
          };
          this.showTaskRows = [...map.values()];
          this.showTaskType = 'batchAdd'; 
          this.showTaskDrawer = true
      }else{
        // 保存一下刚才选中的调查员
        let array = []
        this.curAllKeysItems.forEach(i => {
          let flag = false
          this.selectioned.forEach(val => {
            if (
              val[this.combineField.concat] == i[this.combineField.concat] &&
              val[this.combineField.id] == i[this.combineField.id]
            ) {
              flag = true
              array.push({
                [this.combineField.concat]: i[this.combineField.concat],
                checked: true
              })
            }
          })
          if (flag == false) {
            array.push({
              [this.combineField.concat]: i[this.combineField.concat],
              checked: false
            })
          }
        })
        //this.preAllInterviewerIdsStatus = array
  
        this.flag = false

      }
    },
    comebackHandler() {
      this.$emit('inputValueChange', this.temParams)
      this.selectioned = []
      this.$refs.tableRef.clearSelection()
      this.selectedInterviewerInfo = new Map()
      this.flag = true
    },
    // 问卷开关变化处理函数
    switchChangeHandler(row, newVal) {
      this.switchChangeFunc(this.parseParamsFunc(row, newVal))
        .then(res => {
          this.$message.success('开关状态修改成功')
          this.successFunc && this.successFunc(row)
          this.$emit('inputValueChange', this.temParams)
        })
        .catch(e => {
          this.$message.error('开关状态修改失败')
          this.$emit('inputValueChange', this.temParams)
          console.log(e.message)
        })
    },
    // 当前页码改变时候的处理函数
    currentChangeHandler(newVal) {
      this.loading = true
      //切换页码时，保存当前选中页全部行的选中状态
      // let array = []
      // this.curAllKeysItems.forEach(i => {
      //   let flag = false
      //   this.selectioned.forEach(val => {
      //     if (
      //       val[this.combineField.concat] == i[this.combineField.concat] &&
      //       val[this.combineField.id] == i[this.combineField.id]
      //     ) {
      //       flag = true
      //       array.push({
      //         [this.combineField.concat]: i[this.combineField.concat],
      //         checked: true
      //       })
      //     }
      //   })
      //   if (flag == false) {
      //     array.push({
      //       [this.combineField.concat]: i[this.combineField.concat],
      //       checked: false
      //     })
      //   }
      // })
      // this.preAllInterviewerIdsStatus = array

      // this.temParams.current = newVal
      this.$refs.tableRef.clearSelection();
      // this.total = 0;
      this.selectioned = [];
      this.$emit('inputValueChange', this.temParams)
      this.isIndeterminate = false;
    },
    sizeChangeHandler(newVal) {
      this.temParams.current = newVal
      this.$emit('inputValueChange', this.temParams)
    },
    // inputValueChangeHandler() {
    //   this.$emit('inputValueChange', this.temParams)
    // },
    // statusChangeHandler(newVal) {
    //   this.$emit('inputValueChange', this.temParams)
    // },
    // 清除editTemData中的数据
    clearTemData() {
      // 恢复字段默认
      this.editTemData.temTaskName = ''
      this.editTemData.temEndTime = ''
      this.editTemData.temCount = ''
      this.editTemData.temPrice = ''
    },
    // 用来判断是否可以勾选多选框
    displayCheckBox(row) {
      if (this.tableData.find(item => item.show === true)) {
        return false
      }
      return true
    },
    select(val, row) {
      let obj = val.find(v => v[this.combineField.id] == row[this.combineField.id])
      console.log('obj', obj, val, row)
      let newVal = []
      if (!obj) {
        newVal = val.filter(v => v[this.combineField.concat] != row[this.combineField.concat])
        this.$refs.tableRef.clearSelection()
        newVal.forEach(i => {
          this.$refs.tableRef.toggleRowSelection(i, true)
        })
      } else {
        if (this.channel == 'proxy') {
          newVal = val.filter(v => v[this.combineField.name] != row[this.combineField.name])
          this.tableData.forEach(i => {
            if (i[this.combineField.name] == row[this.combineField.name]) {
              newVal.push(i)
            }
          })
          this.$refs.tableRef.clearSelection()
          newVal.forEach(i => {
            this.$refs.tableRef.toggleRowSelection(i, true)
          })
        } else {
          newVal = val.filter(v => v[this.combineField.concat] != row[this.combineField.concat])
          this.tableData.forEach(i => {
            if (i[this.combineField.concat] == row[this.combineField.concat]) {
              newVal.push(i)
            }
          })
          this.$refs.tableRef.clearSelection()
          newVal.forEach(i => {
            this.$refs.tableRef.toggleRowSelection(i, true)
          })
        }
      }
      this.selectAllChange(newVal)
    },
    selectAllChange(selection) {
      this.selectedInterviewerInfo = new Map()
      selection.forEach(item => {
        if (this.channel === 'proxy') {
          this.selectedInterviewerInfo.set(item[this.combineField.name], item)
        } else {
          this.selectedInterviewerInfo.set(item[this.combineField.concat], item)
        }
      })
      // // if 是数据减少的情况 就是取消了多选框
      // if (this.selectioned.length > selection.length) {
      //   this.selectioned.forEach(item => {
      //     let res = selection.find(n => n.key === item.key)
      //     if (res == undefined) {
      //       this.selectedInterviewerInfo.delete(item[this.combineField.concat])
      //     }
      //   })
      // } else {
      //   // else 是数据增加的情况 就是增加了多选框
      //   selection.forEach(item => {
      //     let res = this.selectioned.find(n => n.key === item.key)
      //     if (res == undefined) {
      //       this.selectedInterviewerInfo.set(item[this.combineField.concat], item)
      //     }
      //   })
      // }
      this.selectioned = selection
      this.isIndeterminate = selection.length > 0 && selection.length < this.total
    },
    // 表格多选框发生变化触发的事件
    selectionChangeHandler(selection) {
      if (this.selectionChangeFlag) {
        this.selectioned = selection
        this.selectionChangeFlag = false
      }
    },
    changeTableSelect(val) {
      this.selectionChangeFlag = true
      if (val) {
        this.$refs.tableRef.clearSelection()
        this.$refs.tableRef.toggleAllSelection()
        this.$nextTick(() => {
          this.selectAllChange(this.selectioned)
        })
      } else {
        this.$refs.tableRef.clearSelection()
        this.$nextTick(() => {
          this.selectAllChange(this.selectioned)
          this.isAll = false
        })
      }
    },
    onCheckedChange(val) {
      if (val) {
        this.$refs.tableRef.clearSelection()
        this.$refs.tableRef.toggleAllSelection()
      } else {
        this.$refs.tableRef.clearSelection()
      }
      if (!this.tableData.length) return
      this.isAll = val
    },
    // 为每一行绑定row-key
    rowKeyHandler(row) {
      row && (row.key = row[this.combineField.id])
      return row && row[this.combineField.id]
    },
    // 电话访问编辑按钮功能
    look(row) {
      // row.offlineId = row.id
      // delete row.id
      // let query = {}
      // extendObject(query, row)
      this.showTaskTitle = "编辑任务";
      this.curRows = JSON.parse(JSON.stringify(row));
      this.showTaskType = 'edit';
      this.showTaskDrawer = true
      // this.$router.push({
      //   path: `/survey/${GlobalConfig.getSurveyId()}/cati/cati-interview/show-task`,
      //   query
      // })
    },
    // 电话访问添加任务
    addTelephoneNumber(row) {
      this.showTaskTitle = "添加任务";
      this.showTaskType = 'add';
      this.curRows = JSON.parse(JSON.stringify(row));
      this.showTaskDrawer = true
      // this.activeIndex = '1'
      // this.currentRow = row
      // this.form.taskName = row.executionName
      // this.telephoneInterviewerDialogVisible = true
    },
    handleClose() {
      this.telephoneInterviewerDialogVisible = false
      this.clearFormData()
    },
    handleSelect(index) {
      this.activeIndex = index
    },
    createTelephoneTask() {
      let params = {
        execution: {
          surveyId: GlobalConfig.getSurveyId(),
          executionName: this.currentRow.executionName,
          executionQuantity: this.currentRow.executionQuantity,
          executionSingleAmount: this.currentRow.executionSingleAmount,
          executionValidateTo: this.currentRow.executionValidateTo,
          executionDescription: this.currentRow.executionDescription,

          userList: [
            {
              userId: this.currentRow.executionBy,
              userName: this.currentRow.executorName || '',
              phone: this.currentRow.executorPhone,
              justForCode: 'true'
            }
          ]
        }
      }
      // 在原任务上添加
      if (this.activeIndex === '1') {
        let temp = this.handleTextareaContent(this.originTextareaContent)
        let phoneArr = []
        let phoneList = [] // 创建任务的数组
        for (let [phone, name] of temp) {
          // 校验手机号和座机
          if (!(isLandline(phone) || isMobile(phone))) {
            this.$message.error('请输入正确的手机号！')
            return
          }
          phoneArr.push(phone)
          phoneList.push({
            phoneNumber: phone,
            sampleName: name
          })
        }

        // 开始查重 去重
        // 1.查输入框重复
        let repeatPhone = new Set()
        let phone = new Set()
        let content = []
        phoneArr.forEach(item => {
          if (phoneArr.indexOf(item) !== phoneArr.lastIndexOf(item)) {
            repeatPhone.add(item)
          }
          phone.add(item)
        })

        // 下面 if 处理输入框重复的提示和自动去重操作
        if (repeatPhone.size) {
          let tem = Array.from(repeatPhone)

          // 去除输入框中的重复
          let handlerData = this.originTextareaContent.split('\n')
          let map = new Map()
          Array.from(phone).forEach(item => {
            let res = []
            handlerData.forEach(i => {
              if (i.indexOf(item) !== -1) {
                res.push(i)
              }
            })
            map.set(item, res)
          })
          for (let val of map) {
            content.push(val[1][0])
          }
          this.originTextareaContent = content.join('\n')

          // 进行提示
          this.$alert(
            `
            ${tem.slice(0, 3).join('、')}等共计${
              tem.length
            }个号码，<span style="color:#D8001B">在输入框中重复，已为您自动去重</span>，请重新提交。`,
            '重复样本号码提醒',
            {
              confirmButtonText: '确定', // 右边按钮
              cancelButtonText: '查看重复', // 左边按钮
              customClass: 'is-phone-repeat',
              type: 'warning',
              dangerouslyUseHTMLString: true,
              center: true,
              showCancelButton: true,
              showColse: false
            }
          ).then(
            confirm => {
              // 点击【确定】的操作 无操作
            },
            cancel => {
              // 【查看重复】按钮操作
              let data = [['重复号码']].concat(tem.map(item => [item]))
              XlsxUtil.downloadXlsx([data], { filename: '重复号码清单' })
            }
          )
        } else {
          // 这个时候输入框中没有重复了 进行第二步
          // 2.查其他任务重复
          checkPhoneList({
            surveyId: GlobalConfig.getSurveyId(),
            phoneList: phoneArr
          }).then(res => {
            // 和其他任务有重复
            if (res.data.data !== null) {
              this.$alert(
                `
                ${res.data.data
                  .slice(0, 3)
                  .join('、')}，<span style="color:#D8001B">以上号码已经在本问卷其他任务中存在</span>，你要删除这些号码吗？`,
                '重复样本号码提醒',
                {
                  confirmButtonText: '删除',
                  cancelButtonText: '重复添加',
                  customClass: 'is-phone-repeat',
                  type: 'warning',
                  dangerouslyUseHTMLString: true,
                  center: true,
                  showCancelButton: true,
                  showClose: false
                }
              ).then(
                confirm => {
                  // 点击【删除】
                  // 去重问卷其他任务重复号码
                  this.removeRepeat(res.data.data)
                },
                cancel => {
                  // 点击【重复添加】
                  // 原有任务上添加号码
                  updatePhoneList({
                    id: this.currentRow.id,
                    surveyId: GlobalConfig.getSurveyId(),
                    phoneList
                  })
                    .then(res => {
                      this.clearFormData()
                      // 刷新列表数据
                      this.$emit('inputValueChange', this.temParams)
                      this.telephoneInterviewerDialogVisible = false
                      this.$message.success('原有任务添加号码成功！')
                    })
                    .catch(e => {
                      this.$message.error('原有任务添加号码失败')
                    })
                }
              )
            } else {
              // 和其他任务没有重复
              // 原有任务上添加号码
              updatePhoneList({
                id: this.currentRow.id,
                surveyId: GlobalConfig.getSurveyId(),
                phoneList
              })
                .then(res => {
                  this.clearFormData()
                  // 刷新列表数据
                  this.$emit('inputValueChange', this.temParams)
                  this.telephoneInterviewerDialogVisible = false
                  this.$message.success('原有任务添加号码成功！')
                })
                .catch(e => {
                  this.$message.error('原有任务添加号码失败')
                })
            }
          })
        }
      } else if (this.activeIndex === '2') {
        if (this.form.taskName == '' || this.form.endTime == '' || this.form.settleMode == '') {
          // !this.form.taskName && this.$message.error('请正确填写任务名称!');
          this.$message.error('请填写必填项!')
          // !this.form.endTime && this.$message.error('请填写截止时间!');
          return
        }
        // 处理阶梯计价开始数量
        let postData = {}
        if (this.form.settleMode === 3) {
          const cloneLadderSettlement = [...this.form.settleRule.tiers]
          cloneLadderSettlement.forEach((it, i, arr) => {
            if (i > 0) {
              it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
            }
          })
          postData = {
            ...this.form,
            settleRule: {
              ...this.form.settleRule,
              tiers: cloneLadderSettlement
            }
          }
          // postData.ladderSettlement =cloneLadderSettlement;
          this.form = { ...postData }
        }

        // 分配新任务
        params.execution.executionName = this.form.taskName
        params.execution.executionSingleAmount = this.form.price
        // params.execution.executionQuantity = this.form.amount;
        params.execution.executionValidateTo = this.form.endTime
        params.execution.executionDescription = this.form.description
        params.execution.settleMode = this.form.settleMode
        params.execution.settleRule = this.form.settleRule

        let temp = this.handleTextareaContent(this.newTextareaContent)
        let phoneList = []
        let phoneArr = []
        for (let [phone, name] of temp) {
          // 校验手机号和座机
          if (!(isLandline(phone) || isMobile(phone))) {
            this.$message.error('请输入正确的手机号！')
            return
          }
          phoneList.push({
            phoneNumber: phone,
            sampleName: name
          })
          phoneArr.push(phone)
        }
        params.phoneList = phoneList

        // 开始查重 去重
        // 1.查输入框重复
        let repeatPhone = new Set()
        let phone = new Set()
        let content = []
        phoneArr.forEach(item => {
          if (phoneArr.indexOf(item) !== phoneArr.lastIndexOf(item)) {
            repeatPhone.add(item)
          }
          phone.add(item)
        })

        // 下面 if 处理输入框重复的提示和自动去重操作
        if (repeatPhone.size) {
          let tem = Array.from(repeatPhone)

          // 去除输入框中的重复
          let handlerData = this.newTextareaContent.split('\n')
          let map = new Map()
          Array.from(phone).forEach(item => {
            let res = []
            handlerData.forEach(i => {
              if (i.indexOf(item) !== -1) {
                res.push(i)
              }
            })
            map.set(item, res)
          })
          for (let val of map) {
            content.push(val[1][0])
          }
          this.newTextareaContent = content.join('\n')

          // 进行提示
          this.$alert(
            `
            ${tem.slice(0, 3).join('、')}等共计${
              tem.length
            }个号码，<span style="color:#D8001B">在输入框中重复，已为您自动去重</span>，请重新提交。`,
            '重复样本号码提醒',
            {
              confirmButtonText: '确定', // 右边按钮
              cancelButtonText: '查看重复', // 左边按钮
              customClass: 'is-phone-repeat',
              type: 'warning',
              dangerouslyUseHTMLString: true,
              center: true,
              showCancelButton: true,
              showClose: false
            }
          ).then(
            confirm => {
              // 点击【确定】的操作 无操作
            },
            cancel => {
              // 【查看重复】按钮操作
              let data = [['重复号码']].concat(tem.map(item => [item]))
              XlsxUtil.downloadXlsx([data], { filename: '重复号码清单' })
            }
          )
        } else {
          // 这个时候输入框中没有重复了 进行第二步
          // 2.查其他任务重复
          checkPhoneList({
            surveyId: GlobalConfig.getSurveyId(),
            phoneList: phoneArr
          }).then(res => {
            // 和其他任务有重复
            if (res.data.data !== null) {
              this.$alert(
                `
                ${res.data.data
                  .slice(0, 3)
                  .join('、')}，<span style="color:#D8001B">以上号码已经在本问卷其他任务中存在</span>，你要删除这些号码吗？`,
                '重复样本号码提醒',
                {
                  confirmButtonText: '删除',
                  cancelButtonText: '重复添加',
                  customClass: 'is-phone-repeat',
                  type: 'warning',
                  dangerouslyUseHTMLString: true,
                  center: true,
                  showCancelButton: true,
                  showClose: false
                }
              ).then(
                confirm => {
                  // 点击【删除】
                  // 去重问卷其他任务重复号码
                  this.removeRepeat(res.data.data)
                },
                cancel => {
                  // 点击【重复添加】
                  params.execution.executionQuantity = this.newCount
                  // 创建任务
                  creatPhoneTask(params)
                    .then(res => {
                      this.$message.success('创建电话访问任务成功')
                      this.telephoneInterviewerDialogVisible = false
                      this.clearFormData()
                      // 刷新列表数据
                      this.$emit('inputValueChange', this.temParams)
                    })
                    .catch(e => {
                      this.$message.error(`创建失败 ${e.message}`)
                    })
                }
              )
            } else {
              // 和其他任务没有重复
              params.execution.executionQuantity = this.newCount
              // 调用接口创建任务
              creatPhoneTask(params)
                .then(res => {
                  this.$message.success('创建电话访问任务成功')
                  this.telephoneInterviewerDialogVisible = false
                  this.clearFormData()
                  // 刷新列表数据
                  this.$emit('inputValueChange', this.temParams)
                })
                .catch(e => {
                  this.$message.error(`创建失败 ${e.message}`)
                })
            }
          })
        }
      }
    },
    // 去重
    removeRepeat(data) {
      if (this.activeIndex === '1') {
        data.forEach(item => {
          this.originTextareaContent = this.originTextareaContent.replaceAll(item, '')
        })
        this.originTextareaContent = this.originTextareaContent
          .split('\n')
          .filter(i => i !== '' && ![',', '，'].includes(i.charAt(0)))
          .join('\n')
      } else {
        data.forEach(item => {
          this.newTextareaContent = this.newTextareaContent.replaceAll(item, '')
        })
        this.newTextareaContent = this.newTextareaContent
          .split('\n')
          .filter(i => i !== '' && ![',', '，'].includes(i.charAt(0)))
          .join('\n')
      }
    },
    clearFormData() {
      this.originTextareaContent = ''
      this.newTextareaContent = ''
      this.form.taskName = ''
      this.form.price = 0
      this.form.amount = 1
      this.form.endTime = ''
      this.description = ''
    },
    handleTextareaContent(content) {
      let tempContent = content.split('\n').filter(item => item.trim() !== '')
      let tempRes = []
      tempContent.forEach(item => {
        if (item.includes(',')) {
          tempRes.push(item.split(',').map(i => i.trim()))
        } else if (item.includes('，')) {
          tempRes.push(item.split('，').map(i => i.trim()))
        } else {
          tempRes.push([item, ''])
        }
      })

      return tempRes
    },
    notCreateTelephoneTask() {
      this.originTextareaContent = ''
      this.newTextareaContent = ''
      this.telephoneInterviewerDialogVisible = false
    },
    equalCountChange(v, row, field) {
      let ids = this.tableData.findIndex(item => item == row)
      if (field == 'equalCount') {
        if (v > 2147483647) {
          this.$message.warning('不能大于2147483647')
          this.tableData[ids][field] = 2147483646
        }
      } else {
        if (v > 999999999.99) {
          this.$message.warning('不能大于999999999.99')
          this.tableData[ids][field] = 999999999.99
        }
      }
    },
    getMore() {
      this.$refs.onlinePayServiceVisible.openDialog()
    },
    // 新增任务抽屉组件相关方法
    customEvent(val, type) {
      this.modifyVisible = val
      if (type) {
        this.$emit('inputValueChange', this.temParams)
      }
    },
    // 新增任务抽屉组件相关方法
    customProxyEvent(val, type) {
      this.modifyProxyVisible = val
      if (type) {
        this.$emit('inputValueChange', this.temParams)
      }
    },
    // 新增任务抽屉组件相关方法
    customBatchEvent(val, type) {
      this.batchSetingTaskVisible = val
      this.$emit('inputValueChange', this.temParams)
      this.selectioned = []
      this.$refs.tableRef.clearSelection()
      this.selectedInterviewerInfo = new Map()
      if (type) {
        this.$emit('inputValueChange', this.temParams)
      }
    },
    customBatchTelTaskEvent(val){
      this.batchAssignTelTaskVisible = val
      this.$emit('inputValueChange', this.temParams)
      this.selectioned = []
      this.$refs.tableRef.clearSelection()
      this.selectedInterviewerInfo = new Map()
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.form.settleRule = {
        ...this.form.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['form'].clearValidate()
      this.form = {
        ...this.form,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.form.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['form'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.form.settleRule.tiers.length < 5) {
            const lastTiers = this.form.settleRule.tiers[this.form.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }
            const cloneLadderSettlement = this.form.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.form.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.form.settleRule.tiers

        this.form.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    }
  },
  watch: {
    flag(v) {
      this.$emit('flag', v)
    },
    propTableData: {
      handler(newValue) {
        this.tableData = this.propTableData = newValue
        if (this.tableData.length > 0) {
          this.tableCount += 1
        }
        this.combineData()
        // this.isShow=false
        this.$nextTick(() => {
          // if(this.tableCount>0) {
          //   this.$refs.tableRef.doLayout()
          // }
          //this.isShow = true
          this.loading = false
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    temParams() {
      return this.searchParams
    },
    originCount() {
      return this.originTextareaContent === ''
        ? 0
        : this.originTextareaContent.indexOf('\n') == -1
        ? 1
        : this.originTextareaContent.split('\n').filter(item => item.trim() !== '').length
    },
    newCount() {
      return this.newTextareaContent === ''
        ? 0
        : this.newTextareaContent.indexOf('\n') == -1
        ? 1
        : this.newTextareaContent.split('\n').filter(item => item.trim() !== '').length
    },
    aboutPrice() {
      return ((this.form.amount * 100 * this.form.price) / 100 || 0).toFixed(2)
    },
    selectAll() {
      return this.selectioned.length === this.total
    },
    isAll: {
      get() {
        return this.checkAll || false
      },
      set(val) {
        this.$emit('update:checkAll', val)
      }
    },
    totalPriceYuan () {
      if (this.form.settleRule.expectedQuantity && this.form.settleRule.unitPriceYuan) {
        return (this.form.settleRule.expectedQuantity * this.form.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.form.settleRule.expectedQuantity && this.form.settleRule.unitPriceYuan) {
        return ((1 + this.accRate * 1) * (this.form.settleRule.expectedQuantity * this.form.settleRule.unitPriceYuan)).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    },
    isQY() {
      return this.userInfo.isQY
    }
  }
}
</script>

<style lang="scss" scoped>
.selected-interviewer {
  .selected-flex {
    display: flex;
    justify-content: space-between;
  }
  .footer {
    width: 100%;
  }
}
.origin-task {
  width: 80%;
  margin: 0 auto;

  .origin-task-text {
    display: flex;
    margin: 10px 0;
    font-size: 15px;
  }
  .count-text {
    position: relative;
    top: -30px;
  }
}
.new-task {
  .left {
    width: 35%;
    .new-task-text {
      display: flex;
      margin: 10px 0;
      font-size: 15px;
    }
    .count-text {
      position: relative;
      top: -30px;
    }
  }
  .right {
    width: 60%;
  }
}
</style>

<style lang="scss" scoped>
// 下面的代码是重置按钮的样式 将“开”和“关”字显示在按钮中间
.el-switch__label--left {
  position: relative;
  left: 45px;
  color: #fff;
  z-index: -1111;
}
.el-switch__core {
  width: 50px !important;
}
.el-switch__label--right {
  position: relative;
  right: 46px;
  color: #fff;
  z-index: -1111;
}
.el-switch__label--right.is-active {
  z-index: 1111;
  color: #fff !important;
}
.el-switch__label--left.is-active {
  z-index: 1111;
  color: #9c9c9c !important;
}
.el-message-box.is-phone-repeat {
  width: 330px;
  .el-message-box__title {
    justify-content: flex-start;
  }
  .el-message-box__content {
    text-align: left;
    margin-left: 19px;
  }
  .el-message-box__btns {
    text-align: right;
  }
}
.is-success {
  .right-bug {
    span.el-input-number__increase {
      left: 97px !important;
    }
  }
}
::v-deep .el-input-number--small {
  height: unset !important;
  background-color: #f2f5fa !important;
  color: #6c748a !important;
  .el-input__inner {
    background-color: #f2f5fa !important;
    color: #6c748a !important;
  }
}
.settlementType-style .flex-box .pos-abs-box {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 108px;
  padding-right: 12px;
  i {
    content: '*';
    color: #e34152;
    margin-right: 4px;
  }
}
.settlementType-style .flex-settlement .el-form-item {
  margin-bottom: 0 !important;
}
</style>
